import { h, Component } from 'preact';
import { observer } from 'mobx-preact';

import util from '../../lib/util';

@observer
class View extends Component {
    render() {
        const {
            view = () => {},
            id,
            name,
            value,
            help,
            updateField,
            object,
        } = this.props;

        return (
            <div>
                {view(value, { id, name, updateField, object })}

                <small id={`${name}Help`} class='form-text text-muted'>
                    <small class='float-right text-info ml-2'>"{util.getType(value)}"</small>
                    <small class='float-right'>"{name}"</small>
                    {help}
                </small>
            </div>
        );
    }
}

export default View;



// WEBPACK FOOTER //
// ./components/form/view.js